const state = {
  empresas: [],
  ultimaEmpresa: null
}

export default state
